.title {
  color: var(--neutral-10-color);
  font-weight: 500;
  line-height: 22px;
  margin-right: 8px;
}
